class CartGamification extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type;
    this.steps = Array.from(this.querySelectorAll('.cart-gamification__step'));
  }

  connectedCallback() {
    this.init();

    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      this.init();
    });
  }

  init() {
    this.removeEvents();
    this.bindEvents();
    this.variantsToRemove = this.dataset.variantsToRemove;
    this.variantsToAdd = this.querySelector('[data-variant-to-add]');

    //this.initSwipers();

    if (this.variantsToRemove) {
      this.removeVariants();
    }

    if (this.variantsToAdd) {
      this.addVariants();
    }
  }

  async removeVariants() {
    // Vérifier s'il y a des variantes à supprimer
    if (!this.variantsToRemove) return;

    const variants = this.variantsToRemove.split(',').filter(Boolean);
    if (variants.length === 0) return;

    try {
      // Récupérer le panier actuel
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Filtrer les items à supprimer
      const itemsToRemove = cart.items
        .filter((item) => item.properties?.type === this.dataset.gift && variants.includes(item.variant_id.toString()))
        .map((item) => item.key);

      if (itemsToRemove.length === 0) return;

      // Supprimer les items
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: Object.fromEntries(itemsToRemove.map((key) => [key, 0])),
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region,cart-gamification',
          // eslint-disable-next-line camelcase
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('Erreur lors de la mise à jour du panier');

      /* --- Customs methods for this theme to indicate the cart the it needs to refresh */
      const jsonResponse = await response.json();
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-gamification',
        cartData: jsonResponse,
      });
    } catch (error) {
      console.error('Erreur lors de la suppression des variantes:', error);
    }
  }

  async addVariants() {
    // Vérifier s'il y a des variantes à ajouter
    if (!this.variantsToAdd) return;

    const variants = this.variantsToAdd.dataset.variantToAdd.split(',').filter(Boolean);
    if (variants.length === 0) return;

    try {
      // Ajouter les variantes
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: variants.map((variant) => ({
            id: variant,
            quantity: 1,
            properties: { type: this.dataset.gift },
          })),
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region,cart-gamification',
          // eslint-disable-next-line camelcase
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Erreur lors de l'ajout des variantes");

      /* --- Customs methods for this theme to indicate the cart the it needs to refresh */
      const jsonResponse = await response.json();
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-gamification',
        cartData: jsonResponse,
      });
    } catch (error) {
      console.error("Erreur lors de l'ajout des variantes:", error);
    }
  }

  removeEvents() {
    this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      button.removeEventListener('click', this.handleAddToCart.bind(this));
    });

    this.querySelectorAll('.cart-gamification__variant-option input').forEach((input) => {
      input.removeEventListener('change', this.handleVariantChange.bind(this));
    });

    window.removeEventListener('cart:refresh', () => {
      this.refreshCart();
    });

    document.removeEventListener('click', (event) => {
      if (!event.target.closest('cart-gamification details')) {
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    });
  }

  bindEvents() {
    // Gestion des boutons d'ajout au panier
    this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });

    // Gestion des sélecteurs de variantes
    this.querySelectorAll('.cart-gamification__variant-option input').forEach((input) => {
      input.addEventListener('change', this.handleVariantChange.bind(this));
    });

    // Observer les changements du panier
    window.addEventListener('cart:refresh', () => {
      this.refreshCart();
    });

    document.addEventListener('click', (event) => {
      //close details on click outside
      if (!event.target.closest('cart-gamification details')) {
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    });
  }

  handleVariantChange(event) {
    const input = event.currentTarget;
    const label = input.closest('label');
    const productContainer = input.closest('[data-product-id]');
    const addToCartButton = productContainer.querySelector('[data-add-to-cart]');
    const variantId = input.value;
    const summary = productContainer.querySelector('summary .cart-gamification__variant-price');
    const allLabels = productContainer.querySelectorAll('.cart-gamification__variant-option');

    // Retirer la classe active de tous les labels
    allLabels.forEach((l) => l.classList.remove('option-selected'));

    // Ajouter la classe active au label sélectionné
    label.classList.add('option-selected');

    // Mettre à jour le summary
    if (summary) {
      summary.textContent = label.textContent;
    }

    // Mettre à jour le variant ID
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;
      addToCartButton.removeAttribute('disabled');
    }

    input.closest('details').removeAttribute('open');
  }

  initSwipers() {
    this.querySelectorAll('[data-products-slider]').forEach((slider) => {
      if (slider.swiper) return;

      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 24,
          },
        },
      });
    });
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    button.classList.add('loading');
    button.querySelector('.loading__spinner').classList.remove('hidden');
    const productContainer = button.closest('[data-product-id]');
    const variantSelector = productContainer.querySelector('[data-variant-selector]');
    const variantId = button.dataset.variantId || (variantSelector ? variantSelector.value : null);

    if (!variantId) return;

    button.setAttribute('disabled', true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { type: this.dataset.gift },
            },
          ],
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region,cart-gamification',
          // eslint-disable-next-line camelcase
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Erreur lors de l'ajout au panier");

      /* --- Customs methods for this theme to indicate the cart the it needs to refresh */
      const jsonResponse = await response.json();
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-gamification',
        cartData: jsonResponse,
      });
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner').classList.add('hidden');
    }
  }
}

customElements.define('cart-gamification', CartGamification);
